import { render, staticRenderFns } from "./Sendout.vue?vue&type=template&id=0588fde0&scoped=true&"
import script from "./Sendout.vue?vue&type=script&lang=js&"
export * from "./Sendout.vue?vue&type=script&lang=js&"
import style0 from "./Sendout.vue?vue&type=style&index=0&id=0588fde0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588fde0",
  null
  
)

export default component.exports